//Your theme for the new stuff using material UI has been copied here so it doesn't conflict
import { createTheme } from '@mui/material/styles';

const newTheme = createTheme({
  palette: {
    type: 'dark',
    text: {
      primary: '#FFF',
    },
    background: {
      default: '#121212',
      paper: '',
    },
    primary: {
      light: '#DED18D',
      main: '#8392ef',
      dark: '#624B1C',
      contrastText: '#000',
      mainButtonNew: 'rgba(79,79,12,0.2)',
    },
    secondary: {
      light: '#ff7961',
      main: '#f44336',
      dark: '#ba000d',
      contrastText: '#000',
    },
    action: {
      disabledBackground: '#CDCDCD',
      active: '#000',
      hover: '#000',
    },
  },
  typography: {
    color: '#dcc63f',
    fontFamily: ['"Poppins"', 'sans-serif'].join(','),
  },
});

export default newTheme;
